<div class="availability">
  <p class="availability__empty" *ngIf="!showTable">
    登録済みの日程がありません。
  </p>

  <table class="availability__table" *ngIf="showTable">
    <thead>
      <tr>
        <th>No.</th>
        <th>日時</th>
        <th>削除</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let period of periods; index as i">
        <ng-container *ngIf="getRowErrors(period, i) as errors">
          <td class="availability__no">{{ i + 1 }}</td>
          <td
            class="availability__schedule"
            [class.availability__schedule--has-error]="errors.length > 0"
          >
            <div class="availability__input-row">
              <input
                class="availability__input"
                type="date"
                [(ngModel)]="period.date"
                [min]="minDate"
                [disabled]="readonly"
              />
              <input
                class="availability__input"
                type="time"
                [(ngModel)]="period.from"
                [disabled]="readonly"
              />
              <span class="availability__separator">〜</span>
              <input
                class="availability__input"
                type="time"
                [(ngModel)]="period.to"
                [disabled]="readonly"
              />
            </div>
            <div class="availability__errors" *ngIf="errors.length">
              <p class="availability__error" *ngFor="let error of errors">
                {{ error }}
              </p>
            </div>
          </td>
          <td class="availability__actions-col">
            <button
              class="btn btn--white btn--outline-gray btn--small"
              type="button"
              (click)="removeCandidate(i)"
              [disabled]="readonly"
            >
              ✖️
            </button>
          </td>
        </ng-container>
      </tr>
    </tbody>
  </table>
  <div class="availability__add-row">
    <button
      class="footer__btn footer__btn--blue"
      type="button"
      (click)="addCandidate()"
      [disabled]="readonly"
    >
      候補日を追加
    </button>
  </div>
</div>

<div class="footer" *ngIf="!readonly">
  <div class="footer__container">
    <button
      class="footer__btn footer__btn--blue"
      type="button"
      (click)="save()"
    >
      更新する
    </button>
  </div>
</div>
